import LanguageSelector from 'components/GlobalModals/AddGiftMessageModal/LanguageSelector/LanguageSelector';

export default LanguageSelector;
